import Component from "@base/Component.js";
import t from "@/services/translationService.js";

/** Site footer: brand, quick links, copyright. */
export default class Footer extends Component {
  render() {
    const year = new Date().getFullYear();
    return `
      <footer class="site-footer">
        <div class="site-footer__brand">
          <img class="site-footer__logo" src="/logo.png" alt="" />
          <span class="site-footer__name">Picturefox</span>
        </div>
        <nav class="site-footer__links">
          <a href="#/">${t.t("nav.galleries")}</a>
          <a href="#/about">${t.t("nav.about")}</a>
          <a href="#/contact">${t.t("nav.contact")}</a>
          <a href="#/privacy">${t.t("nav.privacy")}</a>
        </nav>
        <div class="site-footer__copy">© ${year} Dario Bolzern · Picturefox</div>
      </footer>`;
  }
}
